import { useCallback } from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import { useCurrentUserAsync } from '#src/app/shared/hooks/session';
import type { ShareActionsOptions } from '#src/app/shared/hooks/share';
import { isLoaded } from '#src/app/shared/utils/async';

export function useGetNonVictoriousShareContent(): ShareActionsOptions['getContent'] {
	const { translate } = useI18n();
	const {
		data: {
			petition: {
				displayTitle,
				signatureState: { signatureGoal },
			},
		},
	} = usePetitionDetailsPageData();

	const currentUserState = useCurrentUserAsync();

	const currentUserName = isLoaded(currentUserState) ? currentUserState.value?.shortDisplayName : undefined;

	return useCallback(
		(channel, type, { url }) => {
			switch (channel) {
				case 'twitter':
					return translate('fe.components.petition_share.share_text_twitter', { petition_title: displayTitle });
				case 'whatsapp':
					return translate('fe.components.petition_share.share_text_whatsapp', { petition_title: displayTitle });
				case 'vk':
					return translate('fe.components.petition_share.share_text', { petition_title: displayTitle });
				case 'line':
					return translate('fe.components.petition_share.share_text', { petition_title: displayTitle });
				case 'email':
					if (type === 'title') return displayTitle;
					return translate('fe.components.petition_share.email_body', {
						title: displayTitle,
						number: signatureGoal.displayedLocalized,
						url,
						from: currentUserName || '',
					});
				case 'sms':
					return translate('fe.components.petition_share.share_text_sms', { petition_title: displayTitle });
				default:
					return '';
			}
		},
		[currentUserName, displayTitle, signatureGoal.displayedLocalized, translate],
	);
}
